import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import * as RewardStepsStyles from './RewardSteps.styles';
import ProceedButton from '../../../ProceedButton';
import RewardStep from '../RewardStep';
import useParamSelector from '../../../../hooks/useParamSelector';
import { AppContextField } from '../../../../context/app/types';
import { InvoiceGroup, OrderMode } from '../../../Orders/utils';
import { OrderStep } from '../../../OrderBuilder/utils/formState';
import { clearCart } from '../../../../store/cart/actions';
import { customerReferred$, referralBonus$ } from '../../../../store/profile/selectors';
import { dateSortedDeliveredOrderCollection$, orderCount$ } from '../../../../store/orders/selectors';
import { invoicesByGroup$ } from '../../../../store/entities/selectors';
import { updateOrderSteps } from '../../../../context/app/actions';
import { useAppContextDispatch } from '../../../../context/app/AppContext';
import { currencyDefaults, locale } from '../../../../utils/intl';

const UNREFERRED_FINAL_STEP = 'Unlock referrals';

const COMPLETE_ORDER = 'Complete your order';
const COMPLETE_ONE_ORDER = 'Complete one of your orders';

function RewardSteps() {
  const { classes: secondaryOrderTextClasses } = RewardStepsStyles.secondaryOrderTextClasses();
  const { classes: orderButtonClasses } = RewardStepsStyles.orderButtonClasses();

  const dispatch = useDispatch();

  const appDispatch = useAppContextDispatch();

  const orderCount = useSelector(orderCount$);
  const paidInvoices = useSelector(invoicesByGroup$(InvoiceGroup.PAID));
  // const upcomingOrders = useSelector(dateSortedUpcomingOrderCollection$());
  const deliveredOrders = useParamSelector(dateSortedDeliveredOrderCollection$, false);

  // const latestOrder = upcomingOrders[0];

  // const orderDate = dateFormat(dateInTimeZone(latestOrder?.deliverAt), 'MMMM d');
  // const orderTime = dateFormat(dateInTimeZone(latestOrder?.deliverAt), "h:mmaaaaa'm'");

  // https://foundco.atlassian.net/browse/FOUND-312?focusedCommentId=10130
  // const scheduledOrder = `Scheduled for ${orderDate} at ${orderTime}`;

  const anInvoiceHasBeenPaid = !!paidInvoices.length;

  // An invoice has NOT been paid and at least one order has been deliverd.
  const awaitingPayment = !anInvoiceHasBeenPaid && !!deliveredOrders.length;

  const customerReferred = useSelector(customerReferred$);

  const referralBonus = useSelector(referralBonus$);
  const referralBonusText = referralBonus
    ? Intl.NumberFormat(locale, currencyDefaults).format(referralBonus).replace('.00', '')
    : '';

  const referred_final_step = `Get ${referralBonusText} concrete cash`;

  const newOrder = () => {
    dispatch(clearCart());
    appDispatch(
      updateOrderSteps({
        [AppContextField.ORDER_MODE]: OrderMode.NEW,
        [AppContextField.ORDER_STEP]: OrderStep.DETAILS,
        [AppContextField.ORDER_ID]: undefined,
        [AppContextField.QUOTE_ID]: undefined,
      })
    );
  };

  return (
    <Box marginX={2}>
      <List disablePadding component="ol" aria-label="steps to earn concrete cash">
        <RewardStep primary="Register with Found" />
        <RewardStep stepNumber={!orderCount && 2} primary="Place your first order">
          {!orderCount && (
            <ProceedButton onClick={newOrder} classes={orderButtonClasses} variant="contained" fullWidth size="medium">
              Order now
            </ProceedButton>
          )}
        </RewardStep>
        <RewardStep
          upcoming={!orderCount}
          stepNumber={!anInvoiceHasBeenPaid && 3}
          primary={orderCount > 1 ? COMPLETE_ONE_ORDER : COMPLETE_ORDER}
        >
          {!!awaitingPayment && (
            <Typography classes={secondaryOrderTextClasses} component="span" variant="subtitle1">
              Pending final invoice
            </Typography>
          )}
        </RewardStep>
        <RewardStep upcoming stepNumber={4} primary={customerReferred ? referred_final_step : UNREFERRED_FINAL_STEP} />
      </List>
    </Box>
  );
}

export default RewardSteps;
